module.exports = __webpack_public_path__ + "static/car-pc/img/star-icon.9fd62e74.svg";